import React, { Component } from "react";
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { commonClass } from "../../helpers/commonClass";
import { history } from "../../helpers/history";


class Ourwinners extends Component {
    constructor(props) {
        super(props);
        this.state = {
            drawtype: props.drawtype,
            pastDrawShow: [],
            currentPageNo: 0,
            NumberofRecord: 6,
            totalPage: 0,
            startinx: 0,
            endinx: 6,
            lfilterdt: [],
            IsValidData: false,
            _dbdrawType: props.send_db_id,
            Allyear: [],
            Allmonth: [{ 'monthName': 'January', 'value': 0 }, { 'monthName': 'February', 'value': 1 }, { 'monthName': 'March', 'value': 2 }, { 'monthName': 'April', 'value': 3 }, { 'monthName': 'May', 'value': 4 }, { 'monthName': 'June', 'value': 5 }, { 'monthName': 'July', 'value': 6 }, { 'monthName': 'August', 'value': 7 }, { 'monthName': 'September', 'value': 8 }, { 'monthName': 'October', 'value': 9 }, { 'monthName': 'November', 'value': 10 }, { 'monthName': 'December', 'value': 11 }],
            CurrentYear: '2025',
            CurrentMonth: {},
            myfavNoID: 0,
            FTPAll: []
        }
    }

    LoadCurrentYear = () => {
        let startyear = 2023;
        let cDate = new Date();
        let cYear = cDate.getFullYear();
        let MonthVal = cDate.getMonth();
        let setyear = [];
        for (let index = startyear; index <= cYear; index++) {
            setyear.push(index + '')
        }
        cYear = cYear + '';
        let getMonthobj = this.state.Allmonth.filter(a => a.value == MonthVal);
        this.setState({ CurrentMonth: getMonthobj[0] });
        this.setState({ CurrentYear: cYear });
        setyear = setyear.filter(a => parseInt(a) <= parseInt(cYear));
        this.setState({ Allyear: setyear });
    }
    componentDidMount() {
        // this.LoadCurrentYear();
        setTimeout(() => {
            this.setjsondata();
            localStorage.setItem('drawtabId', 3);
        }, 100);
    }

    componentDidUpdate(prevState, prevProps) {
        if (this.state.pastDrawShow && this.state.pastDrawShow !== prevProps.pastDrawShow && this.state.pastDrawShow.length != 0 && this.state.IsValidData == false) {
            this.state.IsValidData = true;
            this.setState({ IsValidData: true })
            this.LoadTransactionData()
            // window.allDrawResultPopUp();
        }
        // if (this.state.CurrentYear !== prevProps.CurrentYear) {
        //     this.setjsondata();
        // }
    }


    LoadTransactionData = () => {
        if (this.state.pastDrawShow && this.state.pastDrawShow.length > 0) {
            this.setState({ lfilterdt: this.state.pastDrawShow });
            let ltotpage = Math.trunc(this.state.pastDrawShow.length / this.state.NumberofRecord);
            let ltotpage1 = Math.trunc(this.state.pastDrawShow.length % this.state.NumberofRecord);
            if (ltotpage1 == 0) {
                ltotpage = ltotpage - 1;
            }
            this.setState({ currentPageNo: 0 });
            this.setState({ totalPage: ltotpage })
            this.setState({ startinx: 0, endinx: this.state.NumberofRecord });
        }
        else {
            this.setState({ lfilterdt: [] });
        }
    }



    setjsondata = () => {
        try {
            let hbanner = 0
            if (this.props.appvariables.bVersion) {
                let hbannerVer = this.props.appvariables.bVersion.split("~")
                if (hbannerVer.length > 2) {
                    hbanner = hbannerVer[1]
                }
            }
            // let path = this.state.CurrentYear + '';
            // fetch(process.env.REACT_APP_CDN_URL + `Web/${path}/WEBWinners.json` + "?V" + hbanner)
            fetch(process.env.REACT_APP_CDN_URL + `Web/WEBWinners.json` + "?V" + hbanner)
                .then(response => response.json())
                .then(data => {
                    let Ourwinner = data.winnerList //.filter(fObj => fObj.GameTypeId == this.state._dbdrawType);
                    if (data.baseurl) {
                        Ourwinner.forEach(element => {
                            element.imagPath = data.baseurl + element.imagPath;
                        });
                    }
                    this.setState({ pastDrawShow: Ourwinner })
                    // this.setState({ FTPAll: Ourwinner })
                    // const Getfdata = this.GetFilterdValues(Ourwinner);
                    // this.setState({ pastDrawShow: Getfdata })
                });
        }
        catch (ex) {
            console.log("setjsondata => " + ex)
        }
    };


    loadnxtdata = (st) => {
        if (st == "+") {
            if (this.state.currentPageNo != this.state.totalPage) {
                this.state.currentPageNo = this.state.currentPageNo + 1;
            }
        }
        else if (st == "-") {
            if (this.state.currentPageNo != 0) {
                this.state.currentPageNo = this.state.currentPageNo - 1;
            }
        }
        else if (st == "first") {
            this.state.currentPageNo = 0;
        }
        else if (st == "last") {
            this.state.currentPageNo = this.state.totalPage;
        }
        let _startinx = this.state.currentPageNo * this.state.NumberofRecord;
        let _endinx = _startinx + this.state.NumberofRecord;
        this.setState({ startinx: _startinx, endinx: _endinx });
    }

    setCyear = (e) => {
        this.setState({ CurrentYear: e.target.value })
    }

    setCMonth = (e) => {
        let Getyear = this.state.Allmonth.filter(a => a.value == e.target.value);
        this.state.CurrentMonth = Getyear[0];
        const Getfdata = this.GetFilterdValues(this.state.FTPAll);
        this.state.pastDrawShow = Getfdata;
        this.setState({ pastDrawShow: Getfdata });
    }

    GetFilterdValues = (dataSet) => {
        let data = dataSet;
        let filterddata = [];
        const doubledNumbers = data.map((number) => {
            const dateString = number.date
            const date = new Date(dateString);
            const monthIndex = date.getMonth();
            const year = date.getFullYear() + ''
            // if (this.state.CurrentYear === year) {
            if (this.state.CurrentMonth.value == monthIndex) {
                filterddata.push(number)
            }
            // }
        });
        return filterddata;
    }

    render() {
        const { t } = this.props;
        return (
            <>
                <div class="myAccContHead">
                    <h1><img src="./assets/img/icons/tabs-Our-Winners.png" />{t('lblOurWinner')}</h1>
                </div>

                {/* <div className="profileCont topAlign pb-14 mydrawtabs"> */}
                {/* <div className="mainDrawWinnerText">{t('lblOurWinnerheading')}</div>
                    <div className="text-2xl font-bold text-center">{t('lblOurWinner')}</div> */}
                <div class="ourWinners">
                    {this.state.IsValidData && this.state.pastDrawShow && this.state.pastDrawShow.length > 0 && this.state.pastDrawShow.slice(this.state.startinx, this.state.endinx).map((obj, inx) =>
                        <div class="ourWinnersLi">
                            <div class="ourWinnersLiTop">
                                <div class="winrsImg">
                                    <img src={obj.imagPath + '?' + obj.version} />
                                </div>
                                <div class="winrsName">
                                    <h3>{obj.playername}</h3>
                                    <p>{obj.cityname}</p>
                                </div>
                                <div class="ourWinnersLiBtom">
                                    <span>{obj.winningTypeID == 1 ? <>{t('lblmainwinner')}</> : <>{t('lblrafflewinner')} </>}</span>
                                    <span>{obj.date.split(' ') && obj.date.split(' ')[0] && obj.date.split(' ')[0]}</span>
                                </div>
                                <div class="winAmnt">
                                    {this.props.appvariables.currency} {commonClass.aedCrnyConvert(obj.amount)}
                                </div>
                            </div>
                            {/* <div className={`flex flex-col items-start gap-5 bg-game${this.state.drawtype}${obj.winningTypeID == 2 ? "fade text-[#1d1a1a]" : " text-white"} justify-center h-full rounded-r-2xl px-5 py-7 w-52`} >
                                <div className="text-start w-full">
                                    <p className="font-bold text-lg uppercase">{obj.playername}</p>
                                    <p className="italic capitalize">{obj.cityname}</p>
                                </div>
                                <div className="text-nowrap">
                                    <p className="font-bold text-lg uppercase">
                                        <span className={`text-slate-${obj.winningTypeID == 2 ? '600' : '200'}`}>
                                            {this.props.appvariables.currency}
                                        </span>
                                        <span> {commonClass.aedCrnyConvert(obj.amount)}</span>
                                    </p>
                                    <p className="italic capitalize text-nowrap">{obj.date}</p>
                                    <p className="capitalize">{obj.winningTypeID == 1 ? <>{t('lblmainwinner')}</> : <>{t('lblrafflewinner')} </>}</p>
                                </div>
                            </div> */}
                        </div>)}

                    <>
                        {(!this.state.pastDrawShow || this.state.pastDrawShow.length <= 0) &&
                            <div class="noOrders">
                                <img src="./assets/img/icons/sad.png" />
                                <h3>{t("lblNoDrawsAvailable")}</h3>
                                <p class="margin-bottom-20">{t("lblDrawsIsEmpty")}</p>
                                <div class="formCont updateBtn">
                                    <button onClick={() => { history.push("/") }}>{t('lblBuynow')}</button>
                                </div>
                            </div>}
                    </>
                </div>

                <div class="pagination">
                    <div class="paginationLft">
                        {t('lblshowing')} <span>{this.state.currentPageNo + 1}</span> {t('lblto')} <span>{Math.ceil(this.state.pastDrawShow.length / this.state.NumberofRecord)}</span> {t('lblof')} <span>{this.state.pastDrawShow.length}</span> {t('lblentries')}
                    </div>
                    <div class="paginationLRht">
                        <a onClick={() => this.loadnxtdata("first")}><img src="./assets/img/icons/paginate-2-lft.png" /></a>
                        <a class="" onClick={() => this.loadnxtdata("-")}><img src="./assets/img/icons/paginate-1-lft.png" /></a>
                        <a class="" onClick={() => this.loadnxtdata("+")}><img src="./assets/img/icons/paginate-1-rht.png" /></a>
                        <a onClick={() => this.loadnxtdata("last")} class="" ><img src="./assets/img/icons/paginate-2-rht.png" /></a>
                    </div>
                </div>
            </>
        )
    }
}


function mapStateToProps(state) {
    const { appvariables } = state.loginReducer;
    return { appvariables };

}
export default connect(mapStateToProps)(withTranslation()(Ourwinners))
